import { AgencyAssociatedAccounts } from '@anytag/shared-organisms';
import { useAgencyDetailsContext } from './agency-details-context';

export const AgencyBusiness = () => {
  const { agency } = useAgencyDetailsContext();

  return <AgencyAssociatedAccounts agencyId={agency.id} />;
};
